import React, { useState, useEffect } from 'react';
import styles from './countdown.module.css';

const Countdown = ({ isAfterJan1st2026 }) => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        // Only set up the timer if we're still before January 5th, 2026
        if (!isAfterJan1st2026) {
            const calculateTimeLeft = () => {
                const targetDate = new Date('2026-01-01T00:00:00');
                const now = new Date();
                const difference = targetDate - now;

                if (difference > 0) {
                    setTimeLeft({
                        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                        minutes: Math.floor((difference / 1000 / 60) % 60),
                        seconds: Math.floor((difference / 1000) % 60)
                    });
                } else {
                    // After Jan 1st but before Jan 5th, show zeros
                    setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
                }
            };

            calculateTimeLeft();
            const timer = setInterval(calculateTimeLeft, 1000);

            return () => clearInterval(timer);
        }
    }, [isAfterJan1st2026]);

    const formatTime = (time) => {
        return time.toString().padStart(2, '0');
    };

    return (
        <div className={styles.container}>
            <a className={styles.mainTitleAnchor} href="https://www.totvs.com/blog/fiscal-clientes/reforma-tributaria-versao-1-33-da-nt-2025-002-flexibiliza-validacoes-em-2026/" target="_placeholder" rel="noopener noreferrer">
                <h1 className={styles.mainTitle}>Não corra o risco de fiscalizações e autuações!</h1>
            </a>
            
            {!isAfterJan1st2026 && (
                <>
                    <h3 className={styles.subtitle}>Prepare-se agora para a Reforma Tributária.</h3>
                    
                    <div className={styles.countdownBox}>
                        <div className={styles.bubbleBorderTop}>
                            <p>Faltam</p>
                        </div>
                        
                        <div className={styles.countdown}>
                            <div className={styles.timeUnit}>
                                <span className={styles.timeNumber}>{formatTime(timeLeft.days)}</span>
                                <div className={styles.timeDash}></div>
                                <span className={styles.timeLabel}>Dias</span>
                            </div>
                            <div className={styles.timeSeparator}>:</div>
                            
                            <div className={styles.timeUnit}>
                                <span className={styles.timeNumber}>{formatTime(timeLeft.hours)}</span>
                                <div className={styles.timeDash}></div>
                                <span className={styles.timeLabel}>Horas</span>
                            </div>
                            <div className={styles.timeSeparator}>:</div>
                            
                            <div className={styles.timeUnit}>
                                <span className={styles.timeNumber}>{formatTime(timeLeft.minutes)}</span>
                                <div className={styles.timeDash}></div>
                                <span className={styles.timeLabel}>Minutos</span>
                            </div>
                            <div className={styles.timeSeparator}>:</div>
                            
                            <div className={styles.timeUnit}>
                                <span className={styles.timeNumber}>{formatTime(timeLeft.seconds)}</span>
                                <div className={styles.timeDash}></div>
                                <span className={styles.timeLabel}>Segundos</span>
                            </div>
                        </div>
                        
                        <div className={styles.bubbleBorderBottom}>
                            <p>para 1 de janeiro de 2026</p>
                        </div>
                    </div>
                    
                    <h2 className={styles.secondaryTitle}>A contagem regressiva já começou.</h2>
                    <h3 className={styles.description}>Com a Reforma Tributária, sua empresa precisa estar pronta para continuar emitindo notas fiscais e operando sem interrupções.</h3>
                </>
            )}
        </div>
    );
};

export default Countdown;
